import { render, staticRenderFns } from "./banners-form-template.vue?vue&type=template&id=477886e2&"
import script from "./banners-form-template.vue?vue&type=script&lang=js&"
export * from "./banners-form-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports